import React,{useEffect} from 'react'
import Auth from '../assets/projects/Auth.png'
import Blog from '../assets/projects//blog.png'
import Music from '../assets/projects/music.png'
import Food from '../assets/projects/food.png'
import Shop from '../assets/projects/shop.png'
import Tour from '../assets/projects/tour.png'
import AOS from 'aos'
import 'aos/dist/aos.css'

const Projects = () => {
  useEffect(()=> {
    AOS.init({duration: 1000})
})

  const Projects = () => [
    {
      id: 1,
      src: Auth,
      desc: "Login-Signup Authentication  verification using NextJS + ReactJS + Tailwind CSS + Nodemailer + Mailtrap authentication...",
      demo: "/",
      code: "/"
    },
    {
      id: 2,
      src: Shop,
      desc: "E-commerce shoping website is made using Next.js ReactJS, CSS, Javascript, API with responsiveness",
      demo: "/",
      code: "/"
    },
    {
      id: 3,
      src: Music,
      desc: "Music School Management System using Next.js and Aceternity UI framework as a fresh developer",
      demo: "/",
      code: "/"
    },
    {
      id: 4,
      src: Food,
      desc: "Designed a user interface (UI) and user experience (UX) for a food delivery app using Figma, collaborative design   tool. ",
      demo: "/",
      code: "/"
    },
    {
      id: 5,
      src: Tour,
      desc: "Tour Guide website using React.js and tailwind CSS, Javascript",
      demo: "/",
      code: "/"
    },
    {
      id: 6,
      src: Blog,
      desc: "Blog Website using React.js and  CSS.",
      demo: "/",
      code: "/"
    },
  ]


  return (
    <div name="projects" className='h-auto max-h-screen-lg  bg-gradient-to-b from-black to-gray-800 w-full text-white
     md:h-screen'>
      <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
        <div className='pb-8'>
          <h2 className='text-4xl font-bold inline border-b-4 border-gray-400'>Projects</h2>
          <p className='py-6'>Check out some of my work </p>
        </div>
        <div   className='grid sm:grid-cols-2 md:grid-cols-3 mb-20 gap-8 px-12 sm:px-0'>
          {
            Projects().map(({ id, src, desc, demo, code }) => (

              <div data-aos="fade-in" data-aos-duration="500" key={id} className='shadow-md shadow-gray-600 rounded-lg'>
                <img src={src} alt="Ai" className='rounded-md duration-200 hover:scale-105' />
                <p className='p-2 text-justify font-extralight'>{desc}</p>
                <div className='flex items-center justify-center'>
                  
                  <button className='w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105 bg-gradient-to-l from-gray-700 to-blue-900 rounded-md'>
                    <a href={demo}>Design</a>
                  </button>
                  <button  className='w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105 bg-gradient-to-l from-purple-900 to-gray-700 rounded-md'>
                    <a href={code}>Code</a>
                  </button>
                </div>
              </div>

            ))
          }
        </div>
      </div>
    </div>
  )
}

export default Projects